import { render, staticRenderFns } from "./ClientAccountsList.vue?vue&type=template&id=631b4448&scoped=true"
import script from "./ClientAccountsList.vue?vue&type=script&lang=ts"
export * from "./ClientAccountsList.vue?vue&type=script&lang=ts"
import style0 from "./ClientAccountsList.vue?vue&type=style&index=0&id=631b4448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b4448",
  null
  
)

export default component.exports